import request from '../../utils/request';

// 获取回访SOP列表
export function getVisitSopDetail(params,Authorization) {
  return request({
    url: '/api/visitSOP/getVisitSopDetail',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 获取回访类型
export function getVisitSopType(Authorization) {
  return request({
    url: '/api/visitSOP/getVisitSopType',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 删除回访
export function deleteVisitSop(params,Authorization) {
  return request({
    url: '/api/visitSOP/deleteVisitSop',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 朋友圈SOP-创建朋友圈SOP
export function createFriMomentSop(params,Authorization) {
  return request({
    url: '/api/sop/FriMomentSOP/createFriMomentSop',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 朋友圈SOP-获取朋友圈SOP列表数据
export function getFriMomentSopList(params,Authorization) {
  return request({
    url: '/api/sop/FriMomentSOP/getFriMomentSopList',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 朋友圈SOP-获取指定sopId朋友圈SOP详情
export function getFriMomentDetail(sopId,Authorization) {
  return request({
    url: '/api/sop/FriMomentSOP/getFriMomentDetail/'+ sopId,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 朋友圈SOP-获取朋友圈SOP员工完成情况
export function getFriMomentEmp(params,Authorization) {
  return request({
    url: '/api/sop/FriMomentSOP/getFriMomentEmp',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 朋友圈SOP-逻辑删除朋友圈Sop
export function deleteFriMomentSop(params,Authorization) {
  return request({
    url: '/api/sop/FriMomentSOP/deleteFriMomentSop',
    method: 'DELETE',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}

// 新增好友SOP--发布任务
export function addFriends(params,Authorization) {
  return request({
    url: '/api/sop/addFriends',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 新增好友SOP--列表
export function friendsList(params,Authorization) {
  return request({
    url: '/api/sop/addFriends',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}
// -新增好友SOP--详情
export function friendsDetail(params,Authorization) {
  return request({
    url: '/api/sop/addFriends/'+ params,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 新增好友SOP--数据
export function friendsEmp(params,Authorization) {
  return request({
    url: '/api/sop/addFriends/emp/' + params.sopId,
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// -新增好友SOP--删除
export function friendsDelete(params,Authorization) {
  return request({
    url:  '/api/sop/addFriends/' + params,
    method: 'delete',
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒SOP--列表
export function birthdayList(params,Authorization) {
  return request({
    url:  '/api/sop/birthday',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒SOP--删除
export function birthdayDelete(params,Authorization) {
  return request({
    url:  '/api/sop/birthday/' + params,
    method: 'delete',
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒SOP--详情
export function birthdayDetail(params,Authorization) {
  return request({
    url:  '/api/sop/birthday/' + params,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒SOP--数据
export function birthdayEmp(params,Authorization) {
  return request({
    url:  '/api/sop/birthday/emp/' + params.sopId,
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}

// 消息群发-获取消息群发列表数据
export function getMsgSendList(params,Authorization,isLoading) {
  return request({
    url:  '/api/msgSend/getMsgSendList',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isLoading)
}
// 消息群发-获取消息群发员工完成情况
export function getMsgSendEmp(params,Authorization) {
  return request({
    url:  '/api/msgSend/getMsgSendEmp',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 消息群发-获取指定sopId消息群发详情
export function getMsgSendDetail(params,Authorization) {
  return request({
    url:  '/api/msgSend/getMsgSendDetail/'+params,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒/群发-生日/群发获取生日中企微和院内共同的客户
export function getScreenCus(params,Authorization) {
  return request({
    url:  '/api/commonCus/qwHisCus/getScreenCus',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒SOP--发布任务
export function newBirthday(params,Authorization) {
  return request({
    url:  '/api/sop/birthday',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒/群发-获取客户状态
export function getHisCtmType(Authorization) {
  return request({
    url:  '/api/commonCus/qwHisCus/getHisCtmType',
    method: 'GET',
    headers: {
      "authorization": Authorization
    }
  })
}
// 生日提醒/群发-获取区域
export function getHisArea(Authorization) {
  return request({
    url:  '/api/commonCus/qwHisCus/getHisArea',
    method: 'GET',
    headers: {
      "authorization": Authorization
    }
  })
}
// 创建群发
export function createMsgSend(params,Authorization) {
  return request({
    url:  '/api/msgSend/createMsgSend',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}

/**获取当前系统信息 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
export function getCheckSystem(Authorization) {
  return request({
    url:  '/api/qywechat/checkSystem',
    method: 'GET',
    headers: {
      "authorization": Authorization
    }
  })
}